import React__default from 'react';
import { useProductDetailSlots } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { useProductDetailContext } from '../../../../Context/ProductDetailContext.js';
import { useCLEcommContext } from '../../context/CLEcommContext.js';

const CLDeliveryIndicator = ()=>{
    const { getLabel  } = useIntl();
    const { Slots  } = useProductDetailSlots();
    const { activeVariant  } = useProductDetailContext();
    const { state: { configurations , queries  } ,  } = useCLEcommContext();
    const deliveryItems = [];
    if (queries.left.sku && configurations.left.quantity) {
        deliveryItems.push({
            sku: queries.left.sku,
            quantity: configurations.left.quantity
        });
    }
    if (queries.right.sku && configurations.right.quantity) {
        deliveryItems.push({
            sku: queries.right.sku,
            quantity: configurations.right.quantity
        });
    }
    return Slots.DynamicDeliveryIndicator ? /*#__PURE__*/ React__default.createElement(Slots.DynamicDeliveryIndicator, {
        showLoader: Boolean(queries.left.loading || queries.right.loading),
        deliveryItems: deliveryItems,
        isExcludedFromCheckout: activeVariant.excludedFromCheckout,
        fallbackLabel: getLabel('products.deliveryIndicator.selectPrescription')
    }) : null;
};

export { CLDeliveryIndicator };
//# sourceMappingURL=CLDeliveryIndicator.js.map
